const getUrlFiltros = (filtrado,url) =>{
    let caracter = (url.includes("?")) ? '&' : '?';
    return (filtrado) ? url + caracter  + 'tipo=' + localStorage.getItem('filtro_tipo') + '&valor=' + localStorage.getItem('filtro_valor') : url;
};
export default getUrlFiltros